import axios from 'api/axios';
import { usersV2 } from 'api/users/usersApi';

function logout() {
	return axios.post('logout', null, { baseURL: usersV2 }).then((res) => res.data);
}

export default logout;
